module.exports = __webpack_public_path__ + "static/media/thumbnail.2054c3ec.jpg";